// src/store/actions/productActions.js
import {
  getProducts,
  getMirrorDisplayProducts,
  getFinishedDisplayProducts,
  getAllMirrorProducts,
  getAllFinishedProducts,
  getProductDetail,
  submitOrder, // 新增导入
} from '../../api/productApi';
import {
  fetchProductsRequest,
  fetchMirrorDisplaySuccess,
  fetchFinishedDisplaySuccess,
  fetchAllMirrorsSuccess,
  fetchAllFinishedSuccess,
  fetchProductDetailSuccess,
  fetchProductsFailure,
  createOrderRequest, // 新增
  createOrderSuccess, // 新增
  createOrderFailure, // 新增
} from '../reducers/productSlice';

// 通用的产品获取方法（保留，但可以视需求移除）
export const fetchProducts = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchProductsRequest());
    try {
      const response = await getProducts(params);
      // 根据 params 决定存储到哪个字段，或移除此方法
      dispatch(fetchMirrorDisplaySuccess(response.data)); // 示例，默认存到 displayMirrors
    } catch (error) {
      dispatch(fetchProductsFailure(error.message));
    }
  };
};

// 获取镜像站展示产品
export const fetchMirrorDisplayProducts = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchProductsRequest());
    try {
      const response = await getMirrorDisplayProducts(params);
      dispatch(fetchMirrorDisplaySuccess(response.data));
    } catch (error) {
      dispatch(fetchProductsFailure(error.message));
    }
  };
};

// 获取成品号展示产品
export const fetchFinishedDisplayProducts = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchProductsRequest());
    try {
      const response = await getFinishedDisplayProducts(params);
      dispatch(fetchFinishedDisplaySuccess(response.data));
    } catch (error) {
      dispatch(fetchProductsFailure(error.message));
    }
  };
};

// 获取所有镜像站产品
export const fetchAllMirrorProducts = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchProductsRequest());
    try {
      const response = await getAllMirrorProducts(params);
      dispatch(fetchAllMirrorsSuccess(response.data));
    } catch (error) {
      dispatch(fetchProductsFailure(error.message));
    }
  };
};

// 获取所有成品号产品
export const fetchAllFinishedProducts = (params = {}) => {
  return async (dispatch) => {
    dispatch(fetchProductsRequest());
    try {
      const response = await getAllFinishedProducts(params);
      dispatch(fetchAllFinishedSuccess(response.data));
    } catch (error) {
      dispatch(fetchProductsFailure(error.message));
    }
  };
};

// 获取具体产品详情
export const fetchProductDetail = (productId, params = {}) => {
  return async (dispatch) => {
    dispatch(fetchProductsRequest());
    try {
      const response = await getProductDetail(productId, params);
      console.log('Request params:', { productId, ...params }); // 验证请求参数
      console.log('Response data:', response.data); // 验证返回数据
      dispatch(fetchProductDetailSuccess(response.data));
    } catch (error) {
      dispatch(fetchProductsFailure(error.message));
    }
  };
};

// 新增：提交订单
export const createOrder = (orderData) => {
  return async (dispatch) => {
    dispatch(createOrderRequest());
    try {
      const response = await submitOrder(orderData);
      dispatch(createOrderSuccess(response.data));
      return response.data; // 返回 { payUrl, out_trade_no }
    } catch (error) {
      dispatch(createOrderFailure(error.message));
      throw error;
    }
  };
};